<!-- 案由详情页 -->
<template>
    <div class="v-causedetails">
        <c-header></c-header>
        <div class="content">
            <Breadcrumb separator=">">
                <BreadcrumbItem to="/home">首页</BreadcrumbItem>
                <BreadcrumbItem to="/causelist">事由列表</BreadcrumbItem>
                <BreadcrumbItem>事由详情页</BreadcrumbItem>
            </Breadcrumb>

            <Row class="details-panel" :gutter="16">
                <Col span="17">
                <div class="details">
                    <div class="details-title">{{ DetailsData.causeName}}</div>
                    <div class="details-info">
                        <!-- <p class="info-title">1、事由信息</p> -->
                        <p class="info-item" v-if="DetailsData.excuteTypeName">
                            <span class="info-type">事项类型：</span>
                            <span class="info-content">{{ DetailsData.excuteTypeName}}</span>
                        </p>
                        <p class="info-item" v-if="BizId">
                            <span class="info-type">程序类型：</span>
                            <span class="info-content">{{ BizId.length > 1 ? '一般和简易' : '一般程序' }}</span>
                        </p>
                        <p class="info-item" v-if="FuncUnits">
                            <span class="info-type">事项领域：</span>
                            <span class="info-content">{{ FuncUnits }}</span>
                        </p>
                        <p class="info-item" v-if="PunishType">
                            <span class="info-type">处罚种类：</span>
                            <span class="info-content">{{ PunishType }}</span>
                        </p>
                    </div>

                    <div class="details-cl">
                      <p class="info-item cl-float">
                          裁量情形：
                      </p>
                      <div class="details-cl-table cl-float">
                          <table>
                              <tr>
                                  <th style="width: 10%;">处罚种类</th>
                                  <th style="width: 10%;">违法情形</th>
                                  <th style="width: 40%;">职能级别</th>
                                  <th style="width: 10%;">职能部门</th>
                                  <th style="width: 30%;">裁量情形</th>
                              </tr>
                              <tr v-for="item in ClData" v-if="ClData && ClData.length > 0">
                                  <td style="width: 10%;">{{ item.punishType.excuteTypeName }}</td>
                                  <td style="width: 10%;">{{ item.situationDesc }}</td>
                                  <td style="width: 40%;" v-html="renderArr(item.funcLevels, 'unitFuncLevelName')">
                                  </td>
                                  <td style="width: 10%;" v-html="renderArr(item.funcUnits, 'unitFuncTypeName')"></td>
                                  <td style="width: 30%;" v-html="renderClData(item)"></td>
                              </tr>
                          </table>
                      </div>
                  </div>
                    
                  <div class="details-info">
                      <p class="info-item" v-if="FuncLevels">
                          <span class="info-type">事项层级：</span>
                          <span class="info-content">{{ FuncLevels }}</span>
                      </p>
                      <p class="info-item" v-if="CfItems">
                          <span class="info-type">处罚依据：</span>
                          <span class="info-content" v-html="CfItems"></span>
                      </p>
                  </div>
                  
                  <div class="details-info">
                      <p class="info-item" v-if="WfItems">
                          <span class="info-type">违法依据：</span>
                          <span class="info-content" v-html="WfItems"></span>
                      </p>
                  </div>
                </div>
                </Col>
                <Col span="6">
                <div class="list">
                    <div class="cause-list side-list">
                        <h3>权责列表</h3>
                        <p v-if="SimilarList && SimilarList.length > 0" v-for="(item, index) in SimilarList"
                            @click="selectQuanzeItem(item)">
                            {{ (index + 1) + '.' + item.title }}
                        </p>
                        <p v-if="SimilarList && SimilarList.length == 0">
                            暂无数据
                        </p>
                    </div>
                    <!-- <div class="relate-list side-list">
              <h3>关联案例</h3>
              <p v-for="(item, index) in RelateList" @click="selectQuanzeItem(item)">
                {{ (index + 1) + '.' + item.value }}
              </p>
            </div> -->
                </div>
                </Col>
            </Row>
        </div>
        <c-footer></c-footer>
    </div>
</template>

<script>
    import CHeader from '@/components/CHeader'
    import CFooter from '@/components/CFooter'
    import { reqCauseDetails, reqQuanzeList, reqQuanzeDetails } from "@/api/index";
    export default {
        name: 'VCauseDetails',
        components: {
            CHeader,
            CFooter
        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'causedetails-demo'
                }
            }
        },
        data() {
            return {
                //
                DetailsItem: [],
                // 
                DetailsData: {},
                // 事项领域
                FuncUnits: '',
                // 程序类型
                BizId: '',
                // 处罚种类
                PunishType: '',
                // 事项层级
                FuncLevels: '',
                // 处罚依据
                CfItems: '',
                // 裁量情形
                ClData: [],
                // 违法依据
                WfItems: '',
                SimilarList: [],
                RelateList: [
                    {
                        id: 251397,
                        value: '陶志富通过暗管、渗井、渗坑、灌注或者篡改、伪造监测数据（临公(杜)行罚决字[2019]52572号）'
                    },
                    {
                        id: 255780,
                        value: '陶志富通过暗管、渗井、渗坑、灌注或者篡改、伪造监测数据（临公(杜)行罚决字[2019]52572号）'
                    },
                    {
                        id: 311893,
                        value: '周成昌通过暗管、渗井、渗坑、灌注或者篡改、伪造监测数据（临公(杜)行罚决字[2019]52569号）'
                    },
                    {
                        id: 319239,
                        value: '莫代英通过暗管、渗井、渗坑、灌注或者篡改、伪造监测数据（临公(杜)行罚决字[2019]52568号）'
                    },
                    {
                        id: 329061,
                        value: '山西恒工建筑劳务有限公司私设暗管（衢环江罚字[2018]44号）'
                    }
                ]
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
            reqCauseDetails({ causeId: this.$route.query.id }).then(res => {
                this.DetailsData = res.data.causes[0];
                this.DetailsItem = res.data.lawItems;
                this.renderPunishData(this.DetailsData.punishs);
                this.renderCfItems(this.DetailsItem);
                // this.renderCfItems(this.DetailsData);
                this.renderItems(this.DetailsData);
                this.renderWfItems(this.DetailsData);
                this.getQuanzeListData();
            });
        },
        destroyed() {

        },
        methods: {
            // 功能 渲染裁量数据
            renderClData(data) {
                let result = '';
                // 行政拘留
                if (data.punishType.excuteTypeId == 16) {
                    data.clDetails.forEach(item => {
                        result += `拘留下限：${item.lowerLimit}天； 拘留上限：${item.topLimit}天；<br>`;
                    });
                }
                // 其他处罚
                else if (data.punishType.excuteTypeId == 17) {
                    data.clDetails.forEach(item => {
                        result += `具体处罚内容：${item.punishDetail}<br>`;
                    });
                }
                else {
                    data.clDetails.forEach(item => {
                        // 渲染单位
                        let unit = '';
                        if (item.lowerUnit == 1) {
                            unit = '元';
                        }
                        if (item.lowerUnit == 2) {
                            unit = '倍';
                        }
                        if (item.lowerUnit == 3) {
                            unit = '元/单位';
                        }
                        if (item.lowerUnit == 4) {
                            unit = '%';
                        }

                        // 区间罚款
                        if (item.punishType == 1) {
                            result += `类型：${item.objTypeName}； 罚款类型：区间罚款; <br>罚款下限：${item.lowerLimit}${item.lowerUnitName}； 罚款上限：${item.topLimit}${item.topUnitName}；<br>`;
                        }
                        // 定额罚款
                        if (item.punishType == 2) {
                            result += `类型：${item.objTypeName}； 罚款类型：定额罚款; <br>定额罚款：${item.lowerLimit}${unit}；<br>`;
                        }
                        // 倍比罚款
                        if (item.punishType == 3) {
                            result += `类型：${item.objTypeName}； 罚款类型：倍比罚款; <br>罚款下限：${item.lowerLimit}${unit}； 罚款上限：${item.topLimit}${unit}；<br>罚款基准：${item.standard};<br>`;
                        }
                    });
                }
                return result;
            },

            // 功能 渲染职能级别、职能部门数据
            renderArr(data, key) {
                let result = [];
                data.forEach(item => {
                    result.push(item[key]);
                });
                return result.join(',');
            },

            // 请求 活回去权责清单列表
            getQuanzeListData() {
                // reqQuanzeList({causeId: 2394}).then(res => {
                reqQuanzeList({ causeId: this.$route.query.id }).then(res => {
                    this.SimilarList = res;
                });
            },

            // 功能 选中权责
            selectQuanzeItem(item) {
                this.$router.push({ name: 'QzDetails', query: { id: item.quanZeId }, params: item });
            },

            renderItems(data) {
                if (data.bizId) {
                    this.BizId = data.bizId.substr(0, data.bizId.length - 1).split(',');
                }

                // 处罚种类
                if (data.punishName) {
                    this.PunishType = data.punishName.substr(0, data.punishName.length - 1);
                } else {
                    this.PunishType = '';
                }
            },

            renderWfItems(data) {
                //items
                if (data.items && data.items.length > 0) {
                    // 违法依据
                    let tempItems = [];
                    data.items.forEach(item => {
                      if (item.itemTypeId != 2) {
                        tempItems.push(`${item.lawTitle} ${item.itemName} <br> ${item.itemContent} <br>`);
                      }
                    });
                    this.WfItems = tempItems.join('<br>');
                }
            },

            // renderCfItems(data) {
            //     if (data.items && data.items.length > 0) {
            //         // 处罚依据
            //         let tempCfItem = [];
            //         data.items.forEach(item => {
            //           if (item.itemTypeId == 2) {
            //             tempCfItem.push(`${item.lawTitle ? item.lawTitle : ''} ${item.itemName} <br> ${item.itemContent} <br>`);
            //           }
            //         });
            //         this.CfItems = tempCfItem.join('<br>');
            //     } else {
            //         this.CfItems = ' ';
            //     }
            // },

            renderCfItems(data) {
                if (data && data.length > 0) {
                    // 处罚依据
                    let tempCfItem = [];
                    data.forEach(item => {
                        (item.unitType ? item.unitType : ' ')
                        tempCfItem.push(`${item.lawTitle ? item.lawTitle : ''} ${item.itemName} <br> ${item.itemContent} <br>`);
                    });
                    this.CfItems = tempCfItem.join('<br>');
                } else {
                    this.CfItems = ' ';
                }
            },

            renderPunishData(data) {
                if (data && data.length > 0) {
                    // 事项领域
                    let tempFuncUnit = [];
                    data[0].funcUnits.forEach(item => {
                        tempFuncUnit.push(item.unitFuncTypeName);
                    });
                    this.FuncUnits = tempFuncUnit.join('，');

                    //事项层级
                    let tempFuncLevels = [];
                    data[0].funcLevels.forEach(item => {
                        tempFuncLevels.push(item.unitFuncLevelName);
                    });
                    this.FuncLevels = tempFuncLevels.join('，');
                    // 裁量依据
                    this.ClData = data;
                } else {
                    this.FuncUnits = '';
                    this.FuncLevels = '';
                }
            }
        }
    }
</script>

<style scoped>
    .v-causedetails {
        height: 100%;
        background-color: #f7f8f8;
    }

    .content {
        margin: 0 auto;
        width: 1200px;
        min-height: calc(100% - 50px - 112px);
        background-color: #f7f8f8;
    }

    .details-panel {
        margin-bottom: 20px;
    }

    .details {
        background-color: #fff;
    }

    .list {
        background-color: #f7f8f8;
    }

    .side-list {
        background-color: #fff;
    }

    .details-title {
        padding: 16px;
        border-bottom: 3px solid #cecfd3;
        font-size: 18px;
        font-weight: bold;
        color: #2d4060;
    }

    .details-info {
        padding: 8px 16px;
    }

    .info-title {
        padding: 8px 0;
        margin-bottom: 9px;
        border-bottom: 1px dotted #cfcfcf;
        font-size: 16px;
        font-weight: bold;
        color: #2d4060;
    }

    .info-item {
        overflow: hidden;
        padding: 9px 0;
    }

    .info-item span {
        float: left;
    }

    .info-type {
        /* font-size: 14px; */
        color: #999;
    }

    .info-content {
        width: 90%;
        /* font-size: 14px; */
        color: #515a6e;
    }

    .details-cl {
      overflow: hidden;
    }

    .details-cl .info-item {
        padding: 8px 0 8px 16px;
        color: #999;
    }
    
    .details-cl .cl-float {
      float: left;
    }

    .details-cl-table {
        display: flex;
        width: 744px;
        justify-content: center;
        align-items: center;
        /* margin: 10px 16px 10px 84px; */
    }

    .details-cl-table table {
        width: 100%;
        text-align: center;
    }

    .details-cl-table th {
        padding: 16px 6px;
        width: 20%;
        font-size: 14px;
        font-weight: bold;
        color: #2d4060;
        background-color: #d8e5fa;
    }

    .details-cl-table td {
        padding: 16px 6px;
        width: 20%;
        /* font-size: 14px; */
        font-weight: normal;
        color: #515a6e;
        background-color: #f7f8fc;
    }

    .cause-list,
    .relate-list {
        padding: 14px;
        margin-bottom: 10px;
    }

    .side-list h3 {
        padding-bottom: 8px;
        /* font-size: 16px; */
        color: #2d4060;
        border-bottom: 3px solid #cecfd3;
    }

    .side-list p {
        padding: 8px 0;
        border-bottom: 1px dotted #d4d4d4;
        line-height: 24px;
        cursor: pointer;
    }

    .side-list p:hover {
        color: #1867DD;
    }
</style>